export const PARKING_STATION = "PARKING_STATION";
export const TRACK = "TRACK";
export const INSPECTION = "INSPECTION";
export const EMERGENCY_TAKE_TO_BASE = "EMERGENCY_TAKE_TO_BASE";
export const OTHER = "OTHER";
